import React from "react";

// Two-level env + tenant selector for the AI Assistant engine (B-DEV-1).
// Only rendered in dev uiMode — production reads the tenant from the JWT and the env from
// deployment, so end users never see this.
//
// env values match the backend's VALID_ENVS exactly: dev / stage / prod (NOT "staging").
// The tenant list is the REAL list loaded from tenantApi (passed via `tenants`); we fall back
// to a tiny hardcoded set only when the list hasn't loaded yet, so the dropdown is never empty.
//
// Props:
//   env        : current env value ("dev" | "stage" | "prod")
//   tenant     : current tenant schema/name
//   tenants    : array of tenant rows from tenantApi (objects with name/schema/subdomain) — optional
//   onChange   : ({ env, tenant }) => void

const ENVS = ["dev", "stage", "prod"];
const FALLBACK_TENANTS = ["dbo"];

function tenantValue(t) {
  return t && (t.name || t.schema || t) || "";
}
function tenantLabel(t) {
  return t && (t.subdomain || t.name || t.schema || t) || "";
}

export default function EnvTenantSelector({ env, tenant, tenants, onChange }) {
  const tenantOptions =
    Array.isArray(tenants) && tenants.length > 0
      ? tenants.map((t) => ({ value: tenantValue(t), label: tenantLabel(t) }))
      : FALLBACK_TENANTS.map((t) => ({ value: t, label: t }));

  const firstTenant = tenantOptions[0] ? tenantOptions[0].value : "dbo";

  return (
    <div className="flex gap-2 items-center">
      <label className="text-xs text-gray-500">Env:</label>
      <select
        value={env || "dev"}
        onChange={(e) => onChange({ env: e.target.value, tenant })}
        className="text-xs border border-gray-300 rounded px-2 py-1 bg-gray-50 hover:border-gray-400 focus:outline-none focus:border-blue-500"
      >
        {ENVS.map((e) => (
          <option key={e} value={e}>{e}</option>
        ))}
      </select>

      <label className="text-xs text-gray-500 ml-2">Tenant:</label>
      <select
        value={tenant || firstTenant}
        onChange={(e) => onChange({ env, tenant: e.target.value })}
        className="text-xs border border-gray-300 rounded px-2 py-1 bg-gray-50 hover:border-gray-400 focus:outline-none focus:border-blue-500"
      >
        {tenantOptions.map((t) => (
          <option key={t.value} value={t.value}>{t.label}</option>
        ))}
      </select>
    </div>
  );
}
